import React, { useEffect, useRef, useState } from "react";
import styles from "./serviceOptimisation.module.scss";
import bgVideo from "../../assests/videos/startGif.gif";

const data = [
  {
    id: 1,
    sNo: "01",
    description:
      "Understand User Needs – Dorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate",
  },
  {
    id: 2,
    sNo: "02",
    description:
      "Understand User Needs – Dorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate",
  },
  {
    id: 3,
    sNo: "03",
    description:
      "Understand User Needs – Dorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate",
  },
  {
    id: 4,
    sNo: "04",
    description:
      "Understand User Needs – Dorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate",
  },
  {
    id: 5,
    sNo: "05",
    description:
      "Understand User Needs – Dorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate",
  },
];

const ServiceOptimisation = () => {
  const MyRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        setVisible(entry.isIntersecting);
        console.log(entry.isIntersecting);
      },
      { threshold: 0.1 }
    );
    if (MyRef.current) {
      observer.observe(MyRef.current);
    }

    return () => {
      if (MyRef.current) observer.unobserve(MyRef.current);
    };
  }, [MyRef, visible]);

  return (
    <div className={styles.container}>
      {/* <img
        autoPlay
        muted
        loop
        className={styles.video}
        src={bgVideo}
        alt="Background"
      /> */}
      <div className={styles.wrapper} ref={MyRef}>
        <div className={styles.top}>
          <div className={visible ? styles.topTitleEvent : styles.topTitle}>Service Cost</div>
          <div className={visible ? styles.topSubTitleEvent : styles.topSubTitle}>optimization </div>
          <div className={styles.description}>
            Reduce cloud infrastructure costs by optimizing deployments,
            leveraging intelligent resource management, and selecting the most
            cost-effective solutions tailored to your workload. Maximize
            performance while minimizing expenses through smart scaling,
            workload balancing, and continuous cost analysis across leading
            cloud providers.
          </div>
        </div>
        <div className={visible ? styles.bottomEvent : styles.bottom}>
          <div className={styles.bottomTitle}>FEATURES</div>
          <div className={styles.bottomBottom}>
            {data?.map((item) => (
              <div className={styles.point} key={item?.id}>
                <div className={styles.left}>
                  <div className={styles.number}>{item?.sNo}</div>
                </div>
                <div className={styles.description}>{item?.description}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceOptimisation;
